import { messaging, getToken, onMessage } from './firebase';
import { db } from './firebase';
import { collection, addDoc, query, where, onSnapshot, doc, updateDoc, deleteDoc, getDocs } from 'firebase/firestore';

const notificationsCollection = collection(db, 'notifications');

// Crear una notificación
export const createNotification = async (notification) => {
    try {
        await addDoc(notificationsCollection, {
            ...notification,
            createdAt: new Date(),
            read: false, // Marcar como no leída por defecto
        });
    } catch (error) {
        console.error('Error al crear la notificación:', error);
    }
};

// Escuchar notificaciones en tiempo real
export const onNotificationsSnapshot = (userId, callback) => {
    const q = query(notificationsCollection, where('recipientUid', '==', userId));
    return onSnapshot(q, (snapshot) => {
        const notifications = snapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data(),
        }));
        callback(notifications.filter(n => n.title && n.body)); // Filtrar notificaciones válidas
    });
};
export const requestNotificationPermission = async () => {
    if (!messaging) return null;
    try {
        const vapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY;
        if (!vapidKey) {
            console.warn('VAPID Key no encontrada en variables de entorno (REACT_APP_FIREBASE_VAPID_KEY). Las notificaciones no funcionarán.');
            return null;
        }

        // Enforce Service Worker validation
        if ('serviceWorker' in navigator) {
            const registration = await navigator.serviceWorker.ready;
            const token = await getToken(messaging, {
                vapidKey: vapidKey,
                serviceWorkerRegistration: registration
            });

            if (token) {
                console.log('Token de notificación obtenido con éxito.');
                return token;
            }
        }
    } catch (error) {
        if (error.code === 'messaging/invalid-vapid-key') {
            console.error('La clave VAPID es inválida. Verifique su configuración de Firebase.');
        } else if (error.message.includes('applicationServerKey')) {
            console.error('Error de applicationServerKey: Posiblemente la clave VAPID está malformada o vacía.');
        } else {
            console.error('Error al solicitar permisos de notificación:', error);
        }
    }
};

export const listenForNotifications = (callback) => {
    if (!messaging) return;
    onMessage(messaging, (payload) => {
        console.log('Notificación recibida:', payload);
        if (callback) callback(payload);
    });
};

// Marcar una notificación como leída
export const markNotificationAsRead = async (notificationId) => {
    try {
        const notificationDoc = doc(db, 'notifications', notificationId);
        await updateDoc(notificationDoc, { read: true });
        console.log(`Notificación ${notificationId} marcada como leída.`);
    } catch (error) {
        console.error('Error al marcar la notificación como leída:', error);
    }
};

export const deleteNotification = async (notificationId) => {
    try {
        const notificationDoc = doc(db, 'notifications', notificationId);
        await deleteDoc(notificationDoc);
    } catch (error) {
        console.error('Error al eliminar la notificación:', error);
    }
};

/**
 * Marca todas las notificaciones de un usuario como leídas
 * @param {string} userId - ID del usuario
 */
export const markAllNotificationsAsRead = async (userId) => {
    try {
        const q = query(notificationsCollection,
            where('recipientUid', '==', userId),
            where('read', '==', false)
        );

        const querySnapshot = await getDocs(q);
        const updatePromises = querySnapshot.docs.map(docSnap =>
            updateDoc(doc(db, 'notifications', docSnap.id), { read: true })
        );

        await Promise.all(updatePromises);
        console.log(`Marcadas ${updatePromises.length} notificaciones como leídas.`);
    } catch (error) {
        console.error('Error al marcar todas las notificaciones como leídas:', error);
        throw error;
    }
};